export const API_URL = {
    AUTHORIZATION:'/o/authorize/',
    GET_USER_ACCOUNTS:'/api-v1/account/user-accounts/',
    GET_ACCESS_TOKEN:'/api-v1/auth/get-access-token/',
    GET_USER_PROFILE: '/api-v1/users/retrieve-profile-v2/',
    LOGOUT:'/logout/'
}